import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Phone, Mail, MapPin, ShieldCheck, ArrowRight } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-background text-foreground border-t border-border">
      <div className="container mx-auto px-4 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="space-y-6">
            <Link to="/" className="block">
              <img src="https://pumped-shrew.10web.cloud/wp-content/uploads/2026/03/crglogo-white.png" alt="Catalyst Resource Group, LLC" className="object-contain !w-[200px] !h-[38px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Catalyst Resource Group, LLC works with industrial facilities to safely, efficiently, and profitably recover valuable metals from spent CO catalyst.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Quick Links</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/" className="text-muted-foreground hover:text-ring transition-colors text-sm flex items-center gap-2 group w-fit">
                <span className="w-1.5 h-1.5 rounded-none bg-ring/50 group-hover:bg-ring transition-colors" />
                Home
              </Link>
              <Link to="/TalkToAnExpertPage" className="text-muted-foreground hover:text-ring transition-colors text-sm flex items-center gap-2 group w-fit">
                <span className="w-1.5 h-1.5 rounded-none bg-ring/50 group-hover:bg-ring transition-colors" />
                Contact
              </Link>
            </nav>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <Phone className="w-5 h-5 text-ring shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <span className="font-medium text-foreground">Phone</span>
                  <Link to="tel:9512199312" className="hover:text-ring transition-colors">
                    (951) 219-9312
                  </Link>
                  <span className="text-xs text-muted-foreground/80 mt-1">Curt Harke</span>
                </div>
              </div>
              
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <Mail className="w-5 h-5 text-ring shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <span className="font-medium text-foreground">Email</span>
                  <Link to="/TalkToAnExpertPage" className="hover:text-ring transition-colors">
                    Contact Support
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {}
          
        </div>

        <Separator className="my-12 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/60">
          <p>
            &copy; {currentYear} Catalyst Resource Group, LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="hover:text-ring transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-ring transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}